"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateUserRolesDtoRolesEnum = void 0;
exports.instanceOfUpdateUserRolesDto = instanceOfUpdateUserRolesDto;
exports.UpdateUserRolesDtoFromJSON = UpdateUserRolesDtoFromJSON;
exports.UpdateUserRolesDtoFromJSONTyped = UpdateUserRolesDtoFromJSONTyped;
exports.UpdateUserRolesDtoToJSON = UpdateUserRolesDtoToJSON;
exports.UpdateUserRolesDtoToJSONTyped = UpdateUserRolesDtoToJSONTyped;
/**
 * @export
 */
exports.UpdateUserRolesDtoRolesEnum = {
    User: 'user',
    Admin: 'admin',
    Superadmin: 'superadmin'
};
/**
 * Check if a given object implements the UpdateUserRolesDto interface.
 */
function instanceOfUpdateUserRolesDto(value) {
    if (!('roles' in value) || value['roles'] === undefined)
        return false;
    return true;
}
function UpdateUserRolesDtoFromJSON(json) {
    return UpdateUserRolesDtoFromJSONTyped(json, false);
}
function UpdateUserRolesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'roles': json['roles'],
    };
}
function UpdateUserRolesDtoToJSON(json) {
    return UpdateUserRolesDtoToJSONTyped(json, false);
}
function UpdateUserRolesDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'roles': value['roles'],
    };
}
